"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _focus = require("@react-aria/focus");

var _customRendererPropTypes = _interopRequireDefault(require("../helpers/customRendererPropTypes"));

var _iconRadioUnselected = _interopRequireDefault(require("../../../icons/icon-radio-unselected.svg"));

var _iconRadioSelected = _interopRequireDefault(require("../../../icons/icon-radio-selected.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomRadioRenderer = function customRadioControlRendererFunc(_ref) {
  var storedValue = _ref.storedValue,
      fieldData = _ref.fieldData,
      eventHandler = _ref.eventHandler,
      complete = _ref.complete,
      isValid = _ref.isValid;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "identity-radio-input__label"
  }, fieldData.label), complete && !isValid && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input-control__error--single-use"
  }, "Please answer the following question"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "identity-form__control-row"
  }, fieldData.options.map(function (option) {
    var checked = storedValue === option.value;
    var IconComponent = checked ? _iconRadioSelected["default"] : _iconRadioUnselected["default"];
    var uniqueId = "".concat(fieldData.id).concat(option.value);
    var required = !!(fieldData.validation && fieldData.validation.required);
    return /*#__PURE__*/_react["default"].createElement(_focus.FocusRing, {
      focusRingClass: "radio-focus-ring",
      within: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: uniqueId,
      className: "identity-radio-input-control__wrapper"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: uniqueId,
      className: "radio ".concat(checked ? 'radio--selected' : '')
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "radio__input",
      id: uniqueId,
      name: fieldData.fieldKey,
      type: "radio",
      value: option.value,
      checked: checked,
      onKeyPress: function onKeyPress(event) {
        return eventHandler.onKeyPress(event);
      },
      onChange: function onChange(event) {
        return eventHandler.onChange(event);
      },
      required: required
    }), /*#__PURE__*/_react["default"].createElement(IconComponent, {
      className: "radio__icon"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "radio__label radio__label--split"
    }, /*#__PURE__*/_react["default"].createElement("span", null, option.label)))));
  })));
};

CustomRadioRenderer.propTypes = _customRendererPropTypes["default"];
var _default = CustomRadioRenderer;
exports["default"] = _default;